"use strict";
exports.__esModule = true;
exports.rollDice = void 0;
var rollDice = function () { return (Math.floor(Math.random() * 6) + 1); };
exports.rollDice = rollDice;
